<template>
  <v-card
    v-if="getUser"
    class="navbar"
    tile
    flat
  >
    <v-app-bar flat class="">

      <!-- ----------- LOGO ----------- -->
      <v-toolbar-title>
        <v-img
          alt="Logo do CMF"
          class="logo-top shrink mr-2"
          contain
          v-if="this.logo"
          src="@/assets/logo.svg"
          transition="scale-transition"
          max-height="50px"
          position="center left"
        ></v-img>
        <!-- <v-img
          alt="Logo do 1º Curso de Cannabis Medicinal para Reumatologista"
          class="logo-top shrink mr-2"
          contain
          v-if="this.logo"
          :src="this.logo"
          transition="scale-transition"
          max-height="60px"
          position="center left"
        ></v-img> -->
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="admin-btns hidden-sm-and-down" v-if="this.getAdminToken">
        <v-btn
          color="green"
          :to="'/'"
          class="mr-2"
          text
        >Página inicial</v-btn>
        <v-btn
          color="green"
          :to="'/admin'"
          class="mr-2"
          text
        >Admin</v-btn>
        <!-- CHANGE THEME COLOR -->
        <!-- <v-btn
          icon
          @click.stop="$vuetify.theme.dark = !$vuetify.theme.dark"
        >
          <v-icon>mdi-invert-colors</v-icon>
        </v-btn> -->
      </div>

      <v-spacer></v-spacer>

      <!-- ------------ MENU DESKTOP ------------ -->
      <div class="hidden-sm-and-down">
        <!-- <v-btn v-if="this.curentUser" class="white--text mr-4">
          Olá, <strong>{{ this.curentUser.email }}</strong>
        </v-btn> -->
        <v-btn @click="logout" class="nav-btn" color="red white--text" depressed>
          <span class="mr-2">Sair</span>
        </v-btn>
      </div>
      <!-- <div v-if="this.curentUser" class="white--text mr-4">
        Olá, <strong>{{ this.curentUser.email }}</strong>
      </div>
      <v-btn @click="logout" class="nav-btn" color="white" outlined>
        <span class="mr-2">Sair</span>
      </v-btn> -->

      <!-- ------- MENU MOBILE --------- -->
      <div class="round-corner d-flex d-md-none align-center">

          <!-- CHANGE THEME COLOR -->
          <v-btn
            v-if="admin"
            icon
            large
            color="white"
            @click.stop="$vuetify.theme.dark = !$vuetify.theme.dark"
          >
            <v-icon>mdi-invert-colors</v-icon>
          </v-btn>

        <v-menu top close-on-click class="round-corner">
          <template v-slot:activator="{ on }">
            <v-btn
              text
              fab
              large
              v-on="on"
              color="white"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>

          <v-list class="round-corner">
            <div v-if="this.currentUser && this.admin">
              <v-list-item>
                <v-btn
                  v-if="admin"
                  block
                  :to="'/'"
                  class="mr-2"
                  text
                >Página inicial</v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn
                  v-if="admin"
                  block
                  :to="'/admin'"
                  class="mr-2"
                  text
                >Admin area</v-btn>
              </v-list-item>
            </div>

            <v-divider></v-divider>
            <v-list-item>
              <v-btn @click="logout" class="nav-btn" color="red" text>
                <span class="mr-2">Sair</span>
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
  </v-card>
</template>

<script>
import firebase from 'firebase'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Navbar',
  data(){
    return{
      currentUser: null,
      logo: null,
      admin: false,
    }
  },
  computed: {
    ...mapGetters(['isUserAuth', 'getUser', 'getAdminToken'])
  },
  beforeMount(){
    this.getLogo()
  },
  mounted(){
    // this.getAdminToken ? this.admin = true : this.admin = false
    // firebase.auth().onAuthStateChanged(user => {
    //   if (user){
    //     this.currentUser = user
    //     user.getIdTokenResult().then(idTokenResult => {
    //       this.admin = idTokenResult.claims.admin
    //     })
    //   } else {
    //     this.currentUser = null
    //   }
    // })
  },
  methods: {
    ...mapActions(['signOutAction']),
    // changeTheme() {
    //   window.console.log(this.$vuetify.theme.dark)
    // },
    getLogo(){
      var storageRef = firebase.storage().ref();
      var folderRef = storageRef.child('img')
      var fileName = 'logo.svg';
      let logo = folderRef.child(fileName)
      logo.getDownloadURL().then(imgUrl => {
        this.logo = imgUrl
        // console.log(this.bg)
      })
    },
    logout(){
      this.signOutAction();
      // firebase.auth().signOut()
    },
    // getUser(){
    //   this.currentUser = firebase.auth().currentUser
    // }
  }
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

.toolbar-title{
  position: relative;
}
.mobile-menu{
  position: absolute;
  right: 0;
}
.navbar{

  .logo-top{
    // position: static;
    // width: 180px;
    // filter: brightness(0) invert(1);
  }
  // .v-app-bar{
  //   background-color: transparent !important;
  // }
  .v-app-bar{
    // background-color: $primary !important;
    &.theme--dark{
      background-color: #191919 !important;
    }
  }
  .admin-btns {
    .v-btn--active {
      // background-color: white;
      color: $primary !important;
    }
  }
  .nav-btn {

  }
}
</style>